<template>
  <v-main
    class="d-flex flex-column settings px-8 py-6"
    style="min-height: 100vh; width: 100vw"
  >
    <!-- <div class="text-h5 pt-3 pb-6 pl-4">Configurações da conta</div> -->
    <v-container>
      <v-row class="align-baseline">
        <v-col cols="12" md="3" sm="12">
          <div class="text-h5 mb-5 ml-4 " :class="{ 'text-center': isMobile }">
            <strong>{{ $t("accountSettings.title") }}</strong>
          </div>
          <v-tabs
            :vertical="!isMobile"
            :centered="isMobile"
            v-model="tab"
            background-color="transparent"
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab>
              <v-icon class="mr-2">mdi-account-outline</v-icon
              >{{ $t("accountSettings.personalData.title") }}</v-tab
            >
            <v-tab v-if="$root.auth?.whitelabel?.w?.enabled"
              ><v-icon class="mr-2">mdi-briefcase-outline</v-icon
              >{{ $t("accountSettings.accountData.title") }}</v-tab
            >
            <v-tab  v-if="$root.auth?.whitelabel?.w?.enabled"
              ><v-icon class="mr-2">mdi-map-marker-outline</v-icon
              >{{ $t("accountSettings.address.title") }}</v-tab
            >
            <v-tab
              ><v-icon class="mr-2">mdi-shield-lock-outline</v-icon
              >{{ $t("accountSettings.security.title") }}</v-tab
            >
            <!-- <v-tab>Pedidos</v-tab> -->
          </v-tabs>
        </v-col>
        <v-col class="">
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <user-form
                @success="success.text = $event"
                @error="errors.text = $event"
              ></user-form>
            </v-tab-item>
            <v-tab-item  v-if="$root.auth?.whitelabel?.w?.enabled"><profile-form></profile-form> </v-tab-item>
            <v-tab-item  v-if="$root.auth?.whitelabel?.w?.enabled"><address-list></address-list> </v-tab-item>
            <v-tab-item><Security v-if="(tab == 3 && $root.auth?.whitelabel?.w?.enabled) || (tab == 1 && !$root.auth?.whitelabel?.w?.enabled)"/></v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog width="480" v-model="complete.show">
      <v-card class="mx-auto pt-6 text-center">
        <v-card-title class="text-center mx-auto my-3"><div class="mx-auto text-center">{{ $t('complete.title') }}</div></v-card-title>
        <v-card-text class="pb-9"><v-btn @click="complete.show = false" elevation="0" large color="success">{{ $t('common.ok') }}</v-btn></v-card-text>
        </v-card>
    </v-dialog>

    <v-snackbar
      v-model="showUpdateAlert"
      :timeout="-1"
      color="warning"
      top
      centered
      multi-line
    >
      <div class="d-flex align-center">
        <v-icon class="mr-3" color="white">mdi-alert-circle</v-icon>
        <span>Garanta que seu e-mail e telefone estejam atualizados</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          v-bind="attrs"
          @click="showUpdateAlert = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-main>
</template>
<script>
// import Orders from "./Orders.vue";
import AddressList from "@/components/account/AddressList.vue";
import ProfileForm from "@/components/account/ProfileForm.vue";
import Security from "@/components/account/Security.vue";
import UserForm from "@/components/account/UserForm.vue";
export default {
  name: "SettingsForm",
  components: {
    UserForm,
    ProfileForm,
    AddressList,
    Security
},
  data() {
    return {
      tab: -1,
      showUpdateAlert: false,
      complete: {
        show: false
      }
    };
  },
  computed: {
    isMobile() {
      const result = ["xs", "sm"].includes(this.$vuetify.breakpoint.name);
      console.log("result", result);
      return result;
    },
  },
  mounted() {
    let tab = "";
    if (this.$route.params.tab) tab = this.$route.params.tab;
    const isWhitelabelEnabled = this.$root.auth?.whitelabel?.w?.enabled;
    switch (tab) {
      case "dados-pessoais":
        this.tab = 0;
        break;
      case "dados-da-conta":
        this.tab = 1;
        break;
      case "enderecos":
        this.tab = 2;
        break;
      case "seguranca":
        this.tab = isWhitelabelEnabled ? 3 : 1;
        break;
      // case "pedidos":
      //   this.tab = 3;
      //   break;
      default:
        this.tab = 0;
        break;
    }
    if(this.$route.query.do && this.$route.query.do == 'complete'){
      this.complete.show = true
    }
    
    if(this.$route.query.hasOwnProperty('cdv')){
      this.showUpdateAlert = true
    }
  },
  watch: {
    tab(value) {
      const cdvParam = this.$route.query.hasOwnProperty('cdv') ? '?cdv' : '';
      const isWhitelabelEnabled = this.$root.auth?.whitelabel?.w?.enabled;
      
      switch (value) {
        case 0:
          if (this.$route.params.tab != "dados-pessoais")
            this.$router.replace("/conta/configuracoes/dados-pessoais" + cdvParam);
          break;
        case 1:
          if (isWhitelabelEnabled) {
            if (this.$route.params.tab != "dados-da-conta")
              this.$router.replace("/conta/configuracoes/dados-da-conta" + cdvParam);
          } else {
            if (this.$route.params.tab != "seguranca")
              this.$router.replace("/conta/configuracoes/seguranca" + cdvParam);
          }
          break;
        case 2:
          if (this.$route.params.tab != "enderecos")
            this.$router.replace("/conta/configuracoes/enderecos" + cdvParam);
          break;
          case 3:
          if (this.$route.params.tab != "seguranca")
            this.$router.replace("/conta/configuracoes/seguranca" + cdvParam);
          break;
        // case 3:
        //   if (this.$route.params.tab != "pedidos")
        //     this.$router.replace("/conta/configuracoes/pedidos");
        //   break;
      }
    },
    "$route.params.tab"(value) {
      const isWhitelabelEnabled = this.$root.auth?.whitelabel?.w?.enabled;
      switch (value) {
        case "dados-pessoais":
          if (this.tab != 0) this.tab = 0;
          break;
        case "dados-da-conta":
          if (this.tab != 1) this.tab = 1;
          break;
        case "enderecos":
          if (this.tab != 2) this.tab = 2;
          break;
          case "seguranca":
          const securityTabIndex = isWhitelabelEnabled ? 3 : 1;
          if (this.tab != securityTabIndex) this.tab = securityTabIndex;
          break;
        // case "pedidos":
        //   if (this.tab != 3) this.tab = 3;
        //   break;
        default:
          if (this.tab != 0) this.tab = 0;
          break;
      }
    },
  },
};
</script>
<style>
.settings .v-tab.v-tab {
  justify-content: left;
}
</style>
